import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalActions, ModalContent, ModalTitleInfo } from '@c2fo/liquidity';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import trashCanIcon from '@/shared/assets/trashcan.svg?url';
import getTakerMarketName from '@/utils/getTakerMarketName';

interface TurnOffParticipationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  takerMarket: TakerMarket;
}

const TurnOffParticipationModal = ({ open, onClose, onConfirm, takerMarket }: TurnOffParticipationModalProps) => {
  const { t } = useTranslation();
  const marketName = getTakerMarketName(takerMarket);

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <ModalTitleInfo>{t('core.turnOffParticipationModal.title')}</ModalTitleInfo>
      <ModalContent className="py-0">
        <div className="mb-4 mt-2 flex justify-center">
          <img src={trashCanIcon} alt="trash can" className="h-16 w-16 shrink-0" />
        </div>
        <div className="items-start space-y-4 pb-6 pt-2 text-left">
          <p>{t('core.turnOffParticipationModal.marketDisabled', { marketName })}</p>
          <p className="font-medium">{t('core.turnOffParticipationModal.note')}</p>
        </div>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} variant="secondary">
          {t('core.cancel')}
        </Button>
        <Button variant="destructive" onClick={handleConfirm}>
          {t('core.turnOffParticipationModal.title')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default TurnOffParticipationModal;
